export default __webpack_public_path__ + "static/Muscat_Media_Group-5d049d8a8ddca396ddcdcc0203af9723.jpg";